import { useEffect, useState } from "react";
import api from "@/lib/api";

export const REGIONS = { global: "Global", oman: "Oman", gulf: "Gulf", asia_pacific: "Asia Pacific", europe_africa: "Europe & Africa", americas: "Americas" };
const GULF = "AE BH KW QA SA".split(" ");
const AMERICAS = "US CA MX BR AR CL CO PE EC VE UY PY BO GY SR GF BZ CR SV GT HN NI PA CU DO HT JM TT BS BB".split(" ");
const ASIA = "IN PK BD LK NP BT MV AF CN JP KR KP TW HK MO SG MY ID PH TH VN KH LA MM BN TL MN AU NZ PG FJ".split(" ");
const EUROPE_AFRICA = "GB IE FR DE IT ES PT NL BE LU CH AT DK SE NO FI IS PL CZ SK HU RO BG GR CY MT EE LV LT UA MD BY RS HR SI BA ME AL MK XK RU TR ZA NG KE GH ET TZ UG RW EG MA DZ TN LY SD ZM ZW BW NA AO MZ MG SN CI CM CD CG MU SC".split(" ");

export function browserRegion(languages) {
  for (const language of languages || []) {
    try {
      const code = new Intl.Locale(language).region;
      if (!code) continue; // A language alone is not a location.
      if (code === "OM") return "oman";
      if (GULF.includes(code)) return "gulf";
      if (AMERICAS.includes(code)) return "americas";
      if (ASIA.includes(code)) return "asia_pacific";
      if (EUROPE_AFRICA.includes(code)) return "europe_africa";
      return "global";
    } catch { /* invalid locale: try the next explicit region */ }
  }
  return "global";
}

export function useRegionalImages() {
  const [choice, setChoice] = useState(() => {
    try { const saved = localStorage.getItem("hs_marketing_region"); return saved in REGIONS ? saved : "auto"; }
    catch { return "auto"; }
  });
  const detected = browserRegion(navigator.languages || [navigator.language]);
  const region = choice === "auto" ? detected : choice;
  const [result, setResult] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let current = true;
    setResult(null); setError(false);
    api.get("/public/regional-images", { params: { region } }).then(({ data }) => { if (current) setResult(data); }).catch(() => { if (current) setError(true); });
    return () => { current = false; };
  }, [region]);
  const choose = (value) => {
    setChoice(value);
    try { localStorage.setItem("hs_marketing_region", value); } catch { /* selection still works for this page */ }
  };
  return { choice, choose, region, result, error };
}
